export enum ExportFileType {
    XLSX = 'xlsx',
    PDF = 'pdf',
    TXT = 'txt',
    CSV = 'csv', // TODO: Not yet supported. Backend will throw error if this type is used.
}